/*
 * @Description: 文件类型判断
 * @Author: shiduobin
 * @Date: 2025-12-09 19:17:03
 * @LastEditors: shiduobin
 * @LastEditTime: 2025-12-09 20:20:59
 */

/**
 * 判断文件是否为图片（基于文件后缀名）
 * @param {string|File} file - 文件路径/文件名 或 File 对象
 * @param {string[]} [customImageExts] - 自定义图片后缀列表（可选，会合并到默认列表）
 * @returns {boolean} 是否为图片
 */
function isImageFile(file, customImageExts = []) {
  // 1. 处理边界情况
  if (!file) return false

  // 2. 定义默认支持的图片后缀（全小写）
  const defaultImageExts = [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'bmp',
    'webp',
    'svg',
    'ico',
    'tiff',
    'tif',
    'heic',
    'heif',
    'avif',
  ]

  // 3. 合并默认后缀和自定义后缀，并去重、转小写
  const allImageExts = [
    ...new Set([...defaultImageExts, ...customImageExts.map(ext => ext.trim().toLowerCase())]),
  ]

  // 4. 获取文件后缀（兼容 File 对象和字符串路径/文件名）
  let fileName = ''
  if (typeof file === 'object' && file.name) {
    // 处理 File 对象（如 input[type=file] 选择的文件）
    fileName = file.name
  } else if (typeof file === 'string') {
    // 处理文件路径/文件名字符串
    fileName = file.trim()
  } else {
    return false
  }

  // 5. 提取后缀（处理带点/不带点、多后缀的情况）
  const lastDotIndex = fileName.lastIndexOf('.')
  if (lastDotIndex === -1 || lastDotIndex === fileName.length - 1) {
    // 无后缀 或 后缀只有点（如 "file."）
    return false
  }
  const fileExt = fileName.slice(lastDotIndex + 1).toLowerCase()

  // 6. 判断后缀是否在图片列表中
  return allImageExts.includes(fileExt)
}

export { isImageFile }
